import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import { navLinks, documentLinks } from "./documentLinks";
import CloseIcon from "../../assets/svg/CloseIcon";
import MyLogo from "../../assets/img/add/Omni.png";

export default function Sidebar({ sidebarOpen, toggleSidebar, openModal }) {
  return (
    <Wrapper $open={sidebarOpen} aria-hidden={!sidebarOpen}>
      <SidebarHeader>
        <LogoTile><img src={MyLogo} alt="Omnicom Solutions" /></LogoTile>
        <CloseBtn type="button" onClick={() => toggleSidebar(false)} aria-label="Close navigation"><CloseIcon /></CloseBtn>
      </SidebarHeader>
      <NavLabel>Explore</NavLabel>
      <NavList>
        {navLinks.map((link, index) => (
          <li key={link.to}>
            <span>0{index + 1}</span>
            <Link onClick={() => toggleSidebar(false)} to={link.to} smooth offset={-70}>{link.label}</Link>
          </li>
        ))}
      </NavList>
      <NavLabel>Company documents</NavLabel>
      <DocumentList>
        {documentLinks.map((doc) => (
          <li key={doc.id}>
            <button type="button" onClick={() => { toggleSidebar(false); openModal && openModal(doc); }}>
              {doc.label}<span aria-hidden="true">↗</span>
            </button>
          </li>
        ))}
      </DocumentList>
      <SidebarFooter>Lagos, Nigeria <i /> Telecom &amp; technology infrastructure</SidebarFooter>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: min(420px, 90vw); height: 100dvh; position: fixed; top: 0; right: 0; z-index: 9999;
  padding: 26px; background: #17152f; color: #fff; overflow-y: auto;
  transform: translateX(${({ $open }) => ($open ? "0" : "105%")});
  transition: transform .35s cubic-bezier(.2,.8,.2,1); box-shadow: -20px 0 60px rgba(0,0,0,.2);
`;
const SidebarHeader = styled.div`display: flex; align-items: center; justify-content: space-between; margin-bottom: 48px;`;
const LogoTile = styled.div`width: 180px; padding: 8px 10px; background: #fff; border-radius: 12px; img { width: 100%; }`;
const CloseBtn = styled.button`width: 44px; height: 44px; border: 1px solid rgba(255,255,255,.15); border-radius: 50%; background: transparent; cursor: pointer;`;
const NavLabel = styled.p`margin: 28px 0 10px; color: #a8cf45; font-size: .68rem; font-weight: 800; letter-spacing: .14em; text-transform: uppercase;`;
const NavList = styled.ul`
  li { display: flex; align-items: center; gap: 18px; border-bottom: 1px solid rgba(255,255,255,.1); }
  span { color: rgba(255,255,255,.4); font-size: .7rem; }
  a { flex: 1; padding: 14px 0; color: #fff; font-size: 1.25rem; font-weight: 700; cursor: pointer; }
  a:hover { color: #a8cf45; }
`;
const DocumentList = styled.ul`
  button { width: 100%; display: flex; justify-content: space-between; gap: 16px; padding: 11px 0; border: 0; background: transparent; color: rgba(255,255,255,.78); text-align: left; font-size: .84rem; cursor: pointer; }
  button:hover { color: #a8cf45; }
`;
const SidebarFooter = styled.p`margin-top: 42px; color: rgba(255,255,255,.45); font-size: .72rem; i { display: inline-block; width: 4px; height: 4px; margin: 0 8px 2px; border-radius: 50%; background: #0a9250; }`;
